import { useLayoutEffect, useRef, type MutableRefObject } from 'react';

/**
 * Ссылка на последнее значение: обновляется в layout-эффекте, то есть сразу после коммита каждой
 * перерисовки (в том числе принудительной через `flushSync`). Нужна обработчикам, которые живут
 * дольше одного рендера (горячие клавиши, таймеры) и не должны видеть устаревшее замыкание.
 * Читать только в обработчиках и эффектах, не при рендере.
 */
export function useLatest<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
